/* eslint-disable react-hooks/exhaustive-deps */
import Application from "Application";
import useUserLeague from "hooks/use-user-league/useUserLeague";
import IUserTournament from "model/UserTournament/IUserTournament";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserTournamentAttendees } from "service/user-tournament/actions";
import userTournamentSelector, { userTournamentLoadingSelector } from 'service/user-tournament/selector';

const useUserTournament = () => {
    const dispatch = useDispatch();
    const userTournaments = useSelector(userTournamentSelector);
    const userTournamentsLoading = useSelector(userTournamentLoadingSelector);
    const { userLeagueViewModel: { LeagueAttribution: { League: leagueOfUser } } } = useUserLeague();
    const walletTournamentRevenue: number = useMemo(() => {
        const { defaultPrizePool, tournamentsPerYear } = Application.getInstance();
        const selectedUserTournament = userTournaments.find((tournament: IUserTournament) => tournament.nameOfLeague === leagueOfUser?.Name);
        if (!leagueOfUser || !selectedUserTournament?.attendees) return 0;
        return (defaultPrizePool * tournamentsPerYear * leagueOfUser.CashprizeChunk) / selectedUserTournament.attendees
    }, [userTournaments, leagueOfUser]);

    const refreshLeagueAttendees = () => {
        if (leagueOfUser?.Name) {
            dispatch(fetchUserTournamentAttendees(leagueOfUser.Name))
        }
    }

    useEffect(() => {
        const currentLeagueTournament = userTournaments?.find(tournament => tournament.nameOfLeague === leagueOfUser?.Name);
        if (!currentLeagueTournament && leagueOfUser?.Name && !userTournamentsLoading) {
            dispatch(fetchUserTournamentAttendees(leagueOfUser.Name))
        }
    }, [leagueOfUser, userTournaments, userTournamentsLoading])


    return { walletTournamentRevenue, refreshLeagueAttendees }
}

export default useUserTournament;